(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["accio-size-guide"] && !Shopify.designMode) return;
  try {
    (() => {
    const openButton = document.querySelector('[data-accio-size-guide-open]');
    const dialog = document.querySelector('[data-accio-size-guide-dialog]');
    const closeButton = document.querySelector('[data-accio-size-guide-close]');
    if (!openButton || !dialog || !closeButton || typeof dialog.showModal !== 'function') {
      return;
    }
    openButton.addEventListener('click', (event) => {
      event.preventDefault();
      dialog.showModal();
    });
    closeButton.addEventListener('click', () => {
      dialog.close();
    });
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) {
        dialog.close();
      }
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && dialog.open) {
        event.preventDefault();
        dialog.close();
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
